
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface OtherSubjectCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const OtherSubjectCheckbox: React.FC<OtherSubjectCheckboxProps> = ({ id, checked, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center space-x-2">
      <Checkbox 
        id={id} 
        checked={checked} 
        onCheckedChange={onChange}
      />
      <Label htmlFor={id} className="text-gray-700 cursor-pointer">
        {t('form.fields.otherSubjectLabel')}
      </Label>
    </div>
  );
};

export default OtherSubjectCheckbox;
